import { Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OperationTableRow from './OperationTableRow';

interface Props {
  items: OperationListItem[];
}

const OperationsTable: FC<Props> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <TableContainer w="100%">
      <Table>
        <Thead>
          <Tr>
            <Th>{t('operationsTableName')}</Th>
            <Th>{t('operationsTableDate')}</Th>
            <Th>{t('operationsTableAmount')}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((item, index) => (
            <OperationTableRow
              key={index}
              {...item}
            />
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default OperationsTable;
